import { all, put, select, takeEvery } from 'redux-saga/effects';
import { DEPARTURE_TYPE_OPTIONS } from 'constants/options';
import {
  packageLogisticOperatorDepartureTypeSelector,
  packageLogisticOperatorRemovePacketIDSelector,
  packageLogisticOperatorDepartureItemsSelector,
} from './selectors';
import { name, actions } from './slice';
import { actions as paqueryPointDepartureActions } from '../packagePaquerypointDeparture/slice';

function* initialSaga() {
  const items = yield select(packageLogisticOperatorDepartureItemsSelector);
  if (!items || items.length === 0) {
    const storageItems = localStorage.getItem(name);
    if (storageItems) {
      yield put({
        type: actions.success.type,
        payload: JSON.parse(storageItems),
      });
    }
  }
}

function* updateStoragePackagesSaga() {
  const items = yield select(packageLogisticOperatorDepartureItemsSelector);
  localStorage.setItem(name, JSON.stringify(items));
}

function* removePacketSaga() {
  const departureType = yield select(
    packageLogisticOperatorDepartureTypeSelector,
  );
  const packetID = yield select(packageLogisticOperatorRemovePacketIDSelector);
  switch (departureType) {
    case DEPARTURE_TYPE_OPTIONS.LOGISTIC_OPERATOR:
      yield put({
        type: actions.removePacketSuccess.type,
        payload: packetID,
      });
      break;
    case DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT:
      yield put({
        type: paqueryPointDepartureActions.removePacketSuccess.type,
        payload: packetID,
      });
      break;
    default:
      break;
  }
  yield put({
    type: actions.resetRemovePacketID.type,
  });
}

function* dispatchSuccessSaga({ payload }) {
  const packageIds = payload;
  const items = yield select(packageLogisticOperatorDepartureItemsSelector);
  const filteredPackages = items.filter(
    (packet) => !packageIds.includes(packet.id),
  );
  localStorage.removeItem(name);
  yield put({ type: actions.reset.type });
  if (filteredPackages.length) {
    yield put({ type: actions.updatePackets.type, payload: filteredPackages });
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.initial, initialSaga),
    takeEvery(actions.dispatchPackagesSuccess, dispatchSuccessSaga),
    takeEvery(actions.removePacket, removePacketSaga),
    takeEvery(actions.removePacketSuccess, updateStoragePackagesSaga),
    takeEvery(actions.addPackage, updateStoragePackagesSaga),
  ]);
}
